<template>
	<div class="container pt-6 pb-10">
		<div class="flex flex-col lg:flex-row justify-between items-center mb-6">
			<h1 v-if="isNull" class="page-title">Adauga module</h1>
			<h1 v-else class="page-title">Editeaza module</h1>
		</div>

		<EditModule v-if="currentOferta" :gard_obj="isNull ? module : currentOferta.gard_obj" :tip="'oferta'"
			:id="currentOferta.id_oferta" :country="currentOferta.country"
			:username="currentOferta.username"></EditModule>
	</div>
</template>

<script>
import EditModule from "@/components/Productie/Garduri/EditModule";

export default {
	name: "OfertaGard",
	data() {
		return {
			module: [
				{
					nr: "1",
					tip: "",
					model: "",
					pp_included: false,
					denumire_model: "",
					latime_profil: "",
					// the model's slat pattern, kept on the module so a saved offer keeps its layout
					slat_widths: [],
					min_gol: "",
					// direction of a custom model, which has no code to read it from
					orientare: "",
					distanta_gol: "",
					ranforsare: "false",
					ranforsari_verticale: 0,
					gol_afisat: "",
					p_gol: "",
					nr_profile: "",
					filename: "",
					pret: "",
					// L and H are the opening to cover; the module is derived from them
					opening_based: true,
					latime: "",
					inaltime: "",
					// derived from the opening by the card, kept so the offer and the PDF can show
					// what was actually built without recomputing it
					modul_latime: "",
					modul_inaltime: "",
					poarta_latime: "",
					poarta_inaltime: "",
					toc_inaltime: "",
					canate: "",
					spatiu_lamele: "",
					// clearance a gate needs to open, subtracted from the opening height
					gol_sus: "",
					gol_jos: "",
					latime_pp: "",
					tip_poarta_mare: "",
					// cross-section of a Stalp module, in mm
					tip_stalp: null,
					buc: 1,
					suprafata: "",
					suprafata_pp: "",
					cost_modul: "",
					cost_total: "",
					marja: "",
					pret_modul: "",
				},
			],
		};
	},
	components: {
		EditModule,
	},
	computed: {
		currentOferta() {
			return this.$store.getters.currentOfertaProductie;
		},
		isNull() {
			if (this.currentOferta.gard_obj) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {},
	created: function () {
		this.$store.dispatch("fetchOfertaProductie", this.$route.params.id);
	},
	mounted: function () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
